import { render, staticRenderFns } from "./CsvFormatInfo.vue?vue&type=template&id=8b24fc9c&scoped=true&"
import script from "./CsvFormatInfo.vue?vue&type=script&lang=ts&"
export * from "./CsvFormatInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CsvFormatInfo.vue?vue&type=style&index=0&id=8b24fc9c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b24fc9c",
  null
  
)

export default component.exports